import React from "react";
import "./styles/base.css";
import "./styles/registrationcomplete.css";

export default function RegistrationComplete({ onRestart }) {
  const [askAgain, setAskAgain] = React.useState(null);

  // User chose "Yes" — show a short message then call onRestart to go back to Step1
  function handleYes() {
    setAskAgain(true);
    // small delay so user sees the confirmation text/modal
    setTimeout(() => {
      try {
        onRestart();
      } catch (e) {
        // swallow if parent didn't provide callback
      }
    }, 700);
  }

  // User chose "No" — show thanks message
  function handleNo() {
    setAskAgain(false);
  }

  // Centered modal for the initial question
  if (askAgain === null) {
    return (
      <div className="form-container registration-complete" aria-live="polite">
        <div className="overlay" role="dialog" aria-modal="true" aria-labelledby="rc-title">
          <div className="modal">
            <h2 id="rc-title">Would you like to register another person?</h2>
            <p className="muted small">Choose Yes to start a new registration or No to finish.</p>
            <div className="actions">
              <button className="btn btn-secondary" onClick={handleYes}>Yes</button>
              <button className="btn btn-primary" onClick={handleNo}>No</button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // If user chose yes and we are about to restart — show short transition
  if (askAgain === true) {
    return (
      <div className="form-container registration-complete" aria-live="polite">
        <div className="overlay" role="status" aria-hidden="false">
          <div className="modal">
            <h2>Taking you to start a new registration...</h2>
            <p className="loading">Preparing a fresh registration form…</p>
          </div>
        </div>
      </div>
    );
  }

  // Final thank-you centered modal
  return (
    <div className="form-container registration-complete" aria-live="polite">
      <div className="overlay" role="status" aria-hidden="false">
        <div className="modal">
          <h2>Thank you for registering for Camp Fusion!</h2>
          <p className="muted small">We appreciate your registration and look forward to seeing you at camp. A confirmation email will be sent to you shortly.</p>
        </div>
      </div>
    </div>
  );
}